/**
 * @generated SignedSource<<ab23a497d64c66dd4a4951644cb41c67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileEditionForm_authenticationConfig",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableEmailConsent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailConsentLabel",
      "storageKey": null
    }
  ],
  "type": "AuthenticationConfig",
  "abstractKey": null
};

node.hash = "fc6283ced9f68c7bfd1a2850facdefcb";

module.exports = node;
